{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Maler",
    "DESCRIPTION": "Se meldingsmalene som synkroniseres fra WhatsApp-innboksene dine. Du oppretter og redigerer en mal hos leverandøren din.",
    "COUNT": "{n} mal | {n} maler",
    "LEARN_MORE": "Lær mer om WhatsApp-maler",
    "SYNC_TEMPLATES": "Synkroniser maler",
    "SYNC_SUCCESS": "Synkronisering av maler er startet for alle WhatsApp-innbokser. Det kan ta noen minutter før endringene vises.",
    "PARTIAL_SYNC_ERROR": "Synkronisering av maler er startet for noen WhatsApp-innbokser, men andre kunne ikke synkroniseres.",
    "SYNC_ERROR": "Kunne ikke starte synkronisering av maler. Prøv igjen.",
    "SEARCH_PLACEHOLDER": "Søk etter innhold eller navn...",
    "MANAGE_IN_META": "Administrer i Meta",
    "LOADING": "Laster inn WhatsApp-maler...",
    "EMPTY": "Fant ingen WhatsApp-maler.",
    "NO_RESULTS": "Ingen maler samsvarer med filtrene dine.",
    "FETCH_ERROR": "Kunne ikke laste inn WhatsApp-maler. Prøv igjen.",
    "PARTIAL_FETCH_ERROR": "Noen WhatsApp-maler kunne ikke lastes inn. Prøv igjen.",
    "LAST_SYNC_ATTEMPT": "Siste synkroniseringsforsøk den {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Ikke sendt inn til godkjenning hos WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Alle innbokser",
      "ALL_LANGUAGES": "Alle språk",
      "ALL_TYPES": "Alle typer"
    },
    "TYPES": {
      "TEXT": "Tekst",
      "IMAGE": "Bilde",
      "VIDEO": "Video",
      "DOCUMENT": "Dokument",
      "CALL_TO_ACTION": "Handlingsoppfordring",
      "COPY_CODE": "Kopier kode"
    },
    "PREVIEW": {
      "TITLE": "Forhåndsvisning av mal",
      "DESCRIPTION": "Se hvordan denne malen vises i WhatsApp.",
      "OPEN": "Forhåndsvis {name}",
      "CLOSE": "Lukk forhåndsvisning",
      "DETAILS": "Maldetaljer",
      "STATUS": "Status",
      "TYPE": "Innholdstype",
      "CATEGORY": "Kategori",
      "LANGUAGE": "Språk",
      "INBOXES": "Innbokser"
    }
  }
}
